import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DialogCopyVariant from "./DialogCopyVariant";

export default function SectionGroupTables({
  groups,
  selectedGroup,
  onSelectGroup,
  renderIcon,
  scenarioPremises,
  currentPremise,
  onCopySuccess,
  classes,
}) {
  const [isCopyDialogOpen, setIsCopyDialogOpen] = useState(false);

  return (
    <Box className={classes.groupsColumn}>
      {groups.map((group) => (
        <Box
          key={group.name}
          className={
            selectedGroup === group.name
              ? `${classes.groupButton} selected`
              : classes.groupButton
          }
          onClick={() => onSelectGroup(group)}
        >
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
            }}
          >
            {renderIcon(group.name)}
            <Box style={{ display: "flex", flexDirection: "column", flex: 1 }}>
              <Typography className={classes.groupName}>
                {group.name}
              </Typography>
              <Typography
                style={{
                  fontSize: "0.7rem",
                  color: "#999",
                  fontWeight: "400",
                  marginTop: "2px",
                }}
              >
                {group.tables.length} table
                {group.tables.length !== 1 ? "s" : ""}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}

      {/* COPY FROM OTHER PREMISE BUTTON */}
      <Box
        onClick={() => setIsCopyDialogOpen(true)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          padding: "12px",
          border: "2px dashed #bbb",
          borderRadius: "4px",
          backgroundColor: "#fafafa",
          cursor: "pointer",
          textAlign: "center",
          transition: "all 0.2s",
          marginTop: "8px",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#f0f0f0";
          e.currentTarget.style.borderColor = "#888";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#fafafa";
          e.currentTarget.style.borderColor = "#bbb";
        }}
      >
        <FileCopyIcon style={{ fontSize: "1rem", color: "#666" }} />
        <Typography
          style={{
            fontSize: "0.8125rem",
            fontWeight: "500",
            color: "#666",
          }}
        >
          Copy relationships from another premise
        </Typography>
      </Box>

      {/* COPY DIALOG */}
      <DialogCopyVariant
        open={isCopyDialogOpen}
        onClose={() => setIsCopyDialogOpen(false)}
        scenarioPremises={scenarioPremises}
        currentPremise={currentPremise}
        onCopySuccess={onCopySuccess}
      />
    </Box>
  );
}

SectionGroupTables.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      level1: PropTypes.number.isRequired,
      tables: PropTypes.array.isRequired,
    }),
  ).isRequired,
  selectedGroup: PropTypes.string,
  onSelectGroup: PropTypes.func.isRequired,
  renderIcon: PropTypes.func.isRequired,
  scenarioPremises: PropTypes.arrayOf(
    PropTypes.shape({
      premise_key: PropTypes.string.isRequired,
      premise_label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  currentPremise: PropTypes.shape({
    premise_key: PropTypes.string.isRequired,
    premise_label: PropTypes.string.isRequired,
  }),
  onCopySuccess: PropTypes.func,
  classes: PropTypes.object.isRequired,
};
